import * as R from 'ramda';
// helpers
import {
  isFunction,
  isNilOrEmpty,
  isNotNilAndNotEmpty,
} from './helpers';
//////////////////////////////////////////////////

const getConfigValueFromStore = (
  configName, configStore, orValue = '',
) => {
  const value = R.path(['configs', configName, 'value'], configStore);

  if (isNotNilAndNotEmpty(value)) return value;

  return R.pathOr(
    orValue,
    ['configs', configName, 'inheritedValue'],
    configStore,
  );
};

const quickClone = (obj) => {
  // Try to clone object with JSON.parse
  // because for complicated objects Ramda.clone
  // can take few seconds
  let clone;

  try {
    clone = JSON.parse(JSON.stringify(obj));
  } catch (error) {
    clone = R.clone(obj);
  }

  return clone;
};

function setDebounce(func, wait) {
  let timeout;

  return function(...args) { // eslint-disable-line
    const context = this;

    clearTimeout(timeout);

    timeout = setTimeout(() => func.apply(context, args), wait);
  };
}

const deepEquals = (obj1, obj2) => {
  let areEqual = false;

  try {
    areEqual = R.equals(JSON.stringify(obj1), JSON.stringify(obj2));
  } catch (error) {
    console.error(`Can't compare equality! Arguments are too complicated. \n${error}`);
  }

  return areEqual;
};

const stopPropagation = (event) => {
  if (isNotNilAndNotEmpty(event) && isFunction(event.stopPropagation)) {
    event.stopPropagation();
  }
};

const getKeysWithEmptyValues = (itemList) => {
  if (isNilOrEmpty(itemList)) return [];

  return R.compose(
    (itemKeys) => R.reduce(R.intersection, R.head(itemKeys), itemKeys),
    R.map(R.compose(R.keys, R.pickBy(isNilOrEmpty))),
  )(itemList);
};

export {
  deepEquals,
  quickClone,
  setDebounce,
  stopPropagation,
  getKeysWithEmptyValues,
  getConfigValueFromStore,
};
